import { MedScoutLoadingIcon } from 'src/components';

const LoadingIndicator = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <MedScoutLoadingIcon />
    </div>
  );
};

export default LoadingIndicator;
